// Centralized status/badge color definitions — single source of truth.
// All domain badge colors derive from the Tailwind-500 palette below.

export const StatusPalette = {
  blue:    '#3b82f6',
  amber:   '#f59e0b',
  green:   '#22c55e',
  red:     '#ef4444',
  slate:   '#64748b',
  orange:  '#f97316',
  purple:  '#8b5cf6',
  indigo:  '#6366f1',
  cyan:    '#0891b2',
  darkRed: '#8b0000',
  gray:    '#6b7280',
};

/** Append a hex-opacity suffix (default `20` = 12.5%) to any hex color. */
export const withOpacity = (color, opacity = '20') => `${color}${opacity}`;

// ── Work Orders ──

export const WorkOrderStatusColors = {
  Open:        StatusPalette.blue,
  InProgress:  StatusPalette.amber,
  OnHold:      StatusPalette.slate,
  Completed:   StatusPalette.green,
  Cancelled:   StatusPalette.red,
};

// Numeric keys: 0=Low, 1=Medium, 2=High, 3=Critical
export const WorkOrderPriorityColors = {
  0: StatusPalette.slate,
  1: StatusPalette.blue,
  2: StatusPalette.amber,
  3: StatusPalette.red,
};

// ── Support Tasks ──

export const SupportTaskStatusColors = {
  Open:        StatusPalette.blue,
  InProgress:  StatusPalette.amber,
  OnHold:      StatusPalette.slate,
  Resolved:    StatusPalette.green,
  Closed:      StatusPalette.slate,
  Backlog:     StatusPalette.purple,
};

export const SupportTaskPriorityColors = {
  Low:      StatusPalette.blue,
  Medium:   StatusPalette.amber,
  High:     StatusPalette.orange,
  Critical: StatusPalette.red,
};

export const SupportTaskTypeColors = {
  Bug:         StatusPalette.red,
  Feature:     StatusPalette.green,
  Improvement: StatusPalette.blue,
  Question:    StatusPalette.slate,
  Problem:     StatusPalette.orange,
};

// ── Form Submissions (numeric status keys) ──

export const SubmissionStatusColors = {
  2: StatusPalette.amber,  // In Review
  3: StatusPalette.green,  // Approved
  4: StatusPalette.red,    // Rejected
};

// ── PDF / WO Report Status ──

export const ReportStatusColors = {
  Pending:    StatusPalette.amber,
  Processing: StatusPalette.blue,
  Completed:  StatusPalette.green,
  Failed:     StatusPalette.red,
};

// ── Sentry ──

export const SentryLevelColors = {
  error:   StatusPalette.red,
  fatal:   StatusPalette.darkRed,
  warning: StatusPalette.amber,
  info:    StatusPalette.blue,
};

export const SentryIssueStatusColors = {
  resolved:   StatusPalette.green,
  unresolved: StatusPalette.red,
  ignored:    StatusPalette.slate,
  new:        StatusPalette.blue,
};

// ── Project Scope ──

export const ProjectScopeColors = {
  Internal: StatusPalette.indigo,
  External: StatusPalette.cyan,
};

// ── Lab Reports ──

export const LabReportStatusColors = {
  Queued:      StatusPalette.slate,
  Processing:  StatusPalette.blue,
  NeedsReview: StatusPalette.amber,
  Ready:       StatusPalette.green,
  Failed:      StatusPalette.red,
};
